// extracted by mini-css-extract-plugin
module.exports = {"scrollbox":"heartbeat_scrollbox_28Z67"};